var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcnMintOptionJpegalerts = function SvgIcnMintOptionJpegalerts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 .5C18.351.5 23.5 5.649 23.5 12S18.351 23.5 12 23.5.5 18.351.5 12 5.649.5 12 .5Z",
    fill: "#252230",
    stroke: "#E1BCE7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.998,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m16.808 8.598-.96.006-1.907-.013v-.987c-.002-.107 0-.213.006-.32.072-.55.359-.94.86-1.17a1.427 1.427 0 0 1 1.394.154c.355.259.551.609.59 1.05l.006 1.266a.029.029 0 0 1 .01.014Z",
    fill: "#E22021"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.321 6.63c.138-.012.214.05.227.188-.033.342-.066.684-.097 1.026-.015.075-.058.098-.13.07a.084.084 0 0 1-.03-.05 50.63 50.63 0 0 1-.097-1.043.185.185 0 0 1 .127-.19Z",
    fill: "#FDFCFC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.947 7.284a4.809 4.809 0 0 0-.006.32c-1.96.002-3.917 0-5.874-.006a.566.566 0 0 1 .427-.31c1.818-.004 3.636-.005 5.453-.004Z",
    fill: "#D8A9DF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.067 7.598c1.957.006 3.915.008 5.874.006v.607H8.007a.244.244 0 0 0-.006-.08 3.955 3.955 0 0 1 .01-.367c.01-.059.03-.115.056-.166Z",
    fill: "#D9ABE1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.334 8.078c.102-.008.15.039.144.14-.037.081-.096.103-.177.063-.068-.08-.057-.149.033-.203Z",
    fill: "#FDFAFA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.999,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.001 8.13a.244.244 0 0 1 .007.08h5.933v.22H8.008A.81.81 0 0 0 8 8.285v-.153Z",
    fill: "#DBADE2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.999,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.001 8.284a.81.81 0 0 1 .007.147h5.933v.16a.02.02 0 0 0-.013.013l-.294-.003a2.626 2.626 0 0 1-.016.017l-.007.453a.857.857 0 0 0-.01.01l-.253.007a.857.857 0 0 1-.01.01 8.017 8.017 0 0 0 0 .46l.01.01c.821.01 1.644.013 2.466.01v.213H8.001v-.047h.007c1.217.001 2.435 0 3.653-.003a.07.07 0 0 0 .01-.063.015.015 0 0 0-.01-.007 502.054 502.054 0 0 0-3.66-.007v-.686c1.066.002 2.13 0 3.193-.007.014-.01.016-.02.007-.033-1.066-.007-2.132-.01-3.2-.007v-.647Z",
    fill: "#DCB1E3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m13.94 8.59 1.907.014h-1.92a.02.02 0 0 1 .014-.013Z",
    fill: "#943C46"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.998,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.927 8.604h1.92l.96-.006c.1-.002.2 0 .3.003l.017.017.007.453.01.01.253.007.01.01c.005.155.005.31 0 .466l-.01.01c-.527.004-1.053.005-1.58.004-.823.003-1.645 0-2.467-.01a.857.857 0 0 0-.01-.01 8.017 8.017 0 0 1 0-.46l.01-.01.254-.007.01-.01.006-.453a2.92 2.92 0 0 0 .017-.017c.098.002.195.003.293.003Z",
    fill: "#47383D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2 8.938c.01.013.008.024-.006.033H8.007v-.034h3.194Z",
    fill: "#FEFEFE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.001 8.93c1.068-.001 2.134 0 3.2.008H8.008v.033h3.186c-1.063.007-2.127.009-3.193.007V8.93Z",
    fill: "#EDD8F1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.001 9.664c1.221-.002 2.441 0 3.66.007H8.008v.073H8v-.08Z",
    fill: "#EFDAF2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.66 9.67c.005.002.008.004.01.008a.07.07 0 0 1-.01.063c-1.217.003-2.435.004-3.653.003v-.073h3.654Z",
    fill: "#FEFEFE"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.998,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.001 9.79h7.813v.72c-1.639-.001-3.276 0-4.913.008-.055.026-.067.066-.037.12.008.01.018.018.03.023 1.638.003 3.276.004 4.914.003h.006v.554c-.006-.124-.009-.248-.006-.374v-.153h-7.8v.153c.002.126 0 .25-.007.374V9.79Z",
    fill: "#DFB8E5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9 10.518c1.637-.007 3.275-.01 4.914-.007v.153h-.007v-.146h-4.906Z",
    fill: "#F6EDF8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9 10.518h4.907v.146c-1.637.001-3.275 0-4.913-.003a.077.077 0 0 1-.03-.023c-.03-.054-.018-.094.037-.12Z",
    fill: "#FEFEFE"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.807 10.844h-7.8v-.153h7.8v.153Z",
    fill: "#E1BBE6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.998,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.008 10.844h7.8c-.003.126 0 .25.006.374v.753h-.006v-.673h-7.8v.266H8v-.346c.007-.124.009-.248.007-.374Z",
    fill: "#E1BCE7"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.808 11.97H8v-.34h.007c1.64.002 3.28 0 4.92-.003a.065.065 0 0 0 .006-.026c.002-.014-.003-.024-.013-.03-1.637-.007-3.274-.01-4.913-.007v-.267h7.8v.674Z",
    fill: "#E2BFE8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.001 11.564h.007c1.639-.002 3.276 0 4.913.007H8.008v.06H8v-.067Z",
    fill: "#F7EEF8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.92 11.57c.01.008.015.018.014.03 0 .01-.003.02-.007.028-1.64.003-3.28.004-4.92.003v-.06h4.914Z",
    fill: "#FEFEFE"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.998,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.001 11.97H15.814v1.44a57.83 57.83 0 0 1-.12-.086l-.52-.42c-.171-.14-.344-.278-.52-.413l-.18-.147a6.147 6.147 0 0 1-.206-.166l-.454.326-.853.607c-1.65-.007-3.301-.009-4.953-.007.002.126 0 .25-.007.373v-1.506Z",
    fill: "#E4C4E9"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.474 12.344a1115.85 1115.85 0 0 1-2.053 4.72c-.196.007-.391.009-.587.007.659-1.522 1.32-3.042 1.987-4.56-.001-.004-.003-.006-.007-.007l.453-.326c.068.057.137.112.207.166Z",
    fill: "#B195D8"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m14.474 12.344.18.147-2 4.573c.236.007.471.01.707.007h1.94c-2.262.009-4.525.009-6.787 0h3.32c.196.002.391 0 .587-.007.688-1.572 1.373-3.145 2.053-4.72Z",
    fill: "#B496D8"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.654 12.49c.176.136.349.274.52.414-.606 1.388-1.21 2.777-1.813 4.167-.236.002-.471 0-.707-.007l2-4.573Z",
    fill: "#B896D9"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.814 12.504c.004 0 .006.003.007.007-.666 1.518-1.328 3.038-1.987 4.56h-.707c.559-1.28 1.115-2.557 1.667-3.834.054-.043.11-.086.167-.126l.853-.607Z",
    fill: "#AB95D8"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m15.174 12.904.52.42-1.633 3.747h-.7c.602-1.39 1.207-2.779 1.813-4.167Z",
    fill: "#BE96D9"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.999,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.961 13.11c-.057.042-.112.084-.167.128-.19.131-.378.264-.566.4a186.206 186.206 0 0 0-3.154 0l-.073-.054-.213-.166c-.265.222-.525.448-.78.68H8v-.62c.007-.124.009-.248.007-.374 1.652-.002 3.303 0 4.953.007Z",
    fill: "#E6C8EB"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.794 13.238c-.552 1.276-1.108 2.554-1.666 3.833h-.707c.447-1.03.896-2.059 1.347-3.087-.001-.004-.004-.006-.007-.007l.467-.34c.188-.135.376-.268.566-.4Z",
    fill: "#A594D8"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m15.694 13.324.12.087c.003 1.045 0 2.09-.006 3.133 0-.62 0-1.24-.004-1.86-.347.795-.693 1.59-1.036 2.387h-.707l1.633-3.747Z",
    fill: "#C497D9"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 13.584c-.326.764-.656 1.526-.99 2.287-.003-.591-.004-1.182-.003-1.774.256-.23.516-.457.78-.68l.214.167Z",
    fill: "#8792D6"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m9 13.584.074.054.454.366c-.427.988-.858 1.972-1.294 2.954a.56.56 0 0 1-.23-.427c-.003-.811-.004-1.622-.003-2.433h.007c-.002.59 0 1.182.003 1.773.334-.761.664-1.523.99-2.287Z",
    fill: "#8C92D6"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m12.228 13.637-.467.34c-.197.136-.393.273-.587.414a25.195 25.195 0 0 0-1.153 0c-.163-.132-.327-.26-.493-.387l-.454-.367c1.051-.008 2.102-.008 3.154 0Z",
    fill: "#E8CBEC"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.76 13.977c.004 0 .007.003.007.007-.45 1.028-.9 2.057-1.346 3.087h-.7c.34-.79.682-1.579 1.026-2.367l.427-.313c.194-.14.39-.278.587-.414Z",
    fill: "#9F94D7"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.528 14.004a20.475 20.475 0 0 1 .526.414c-.387.883-.771 1.767-1.153 2.653h-.387a.49.49 0 0 1-.28-.114c.437-.981.868-1.965 1.294-2.953Z",
    fill: "#9293D7"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.021 14.39c.384-.008.769-.008 1.153 0l-.426.314a4.43 4.43 0 0 0-.177.12 73.107 73.107 0 0 0-.55-.433Z",
    fill: "#E9CEED"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.054 14.418c.173.134.345.27.517.406a4.5 4.5 0 0 1 .177-.12c-.345.788-.687 1.577-1.027 2.367H8.9c.382-.886.766-1.77 1.153-2.654Z",
    fill: "#9893D7"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.808 16.544a.567.567 0 0 1-.407.51.319.319 0 0 1-.1.017h-.533c.343-.796.689-1.592 1.036-2.387.004.62.005 1.24.004 1.86Z",
    fill: "#CA97D9"
  })));
};
export default SvgIcnMintOptionJpegalerts;